import {useEffect} from 'react';
import {useColorMode} from '@tempo/core';
import {
	getThemePreference,
	setThemePreference,
} from '@deezer/next/services/storage/shared/effects';
import {useUser} from '@deezer/next/contexts/main/hooks';
import type {ThemePreference} from '@deezer/next/services/storage/shared/types';

const SharedThemeSync = () => {
	const user = useUser();
	const {setColorMode} = useColorMode();

	const remoteTheme = user?.settings?.user?.theme?.mode as
		ThemePreference | undefined;

	useEffect(() => {
		const storedTheme = getThemePreference();
		setColorMode(storedTheme);
	}, [setColorMode]);

	useEffect(() => {
		if (!remoteTheme) return;

		setThemePreference(remoteTheme);
		setColorMode(remoteTheme);
	}, [remoteTheme, setColorMode]);

	return null;
};

export default SharedThemeSync;
